import React from 'react';
import ButtonCustom from "@ui/buttons/buttonCustom/ButtonCustom";
import {IButtonBaseProps} from "@ui/buttons/buttonCustom/types";
import {sx} from './sx'

interface IProps extends IButtonBaseProps {

}

const SecondaryButtonSingleVoyage = ({
                                       onClick,
                                       children,
                                       fullWidth,
                                       sx: sxProps = {},
                                       startIcon,
                                       endIcon,
                                   }: IProps) => {
    return (
        <ButtonCustom
            sx={{
                ...sx.root,
                ...sxProps,
            }}
            fullWidth={fullWidth}
            onClick={onClick}
            startIcon={startIcon}
            endIcon={endIcon}
            variant={'contained'}
        >
            {children}
        </ButtonCustom>
    );
};

export default SecondaryButtonSingleVoyage;